module.exports = __webpack_public_path__ + "static/img/italy.cc79b18.png";